// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../css-loader/dist/cjs.js??ref--6-oneOf-0-1!../../../../../postcss-loader/dist/cjs.js!../../../../../../src/overrides/venia-ui/components/Field/field.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".textArea-input-Rk3 {\n}\n\n.textArea-input_shimmer-SJm {\n    font-size: 1rem;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input": "textArea-input-Rk3 " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["input"] + " h-auto max-w-full min-w-full px-xs py-3",
	"input_shimmer": "textArea-input_shimmer-SJm h-auto m-0 max-w-full min-h-[6.75rem] min-w-full px-[15px] py-[12px] rounded-md w-full"
};
export default ___CSS_LOADER_EXPORT___;
